export default function checkConditions (conditions, state) {
  if (!conditions) return true
  return conditions.every(rule => {
    if (rule.equals) {
      return state[rule.name] === rule.equals
    } else if (rule.containsOneOf) {
      const arrayToCheck = state[rule.name]
      for (const oneOf of rule.containsOneOf) {
        if (typeof oneOf === 'object') {
          for (const [oneOfKey, oneOfValue] of Object.entries(oneOf)) {
            for (const itemToCheck of arrayToCheck) {
              if (itemToCheck[oneOfKey] === oneOfValue) return true
            }
          }
        } else {
          console.error('Unknown containsOneOf condition', oneOf)
          return false
        }
      }
      return false
    } else {
      console.error('Unknown condition', rule)
      return false
    }
  })
}